<template>
  <AuthWrongBase>
    Lo sentimos, pero has superado el número máximo de intentos de acceso
    permitidos. Por favor, inténtalo de nuevo dentro de una hora
  </AuthWrongBase>
</template>

<script>
import AuthWrongBase from '@/components/AuthWrongBase'

export default {
  components: { AuthWrongBase },
}
</script>
